import { IPropsInputField } from "./fieldPropertiesInterfaceNew";
import InputField from "./inputFieldNew";
import {ReactComponent as SearchIconSVG } from "itd-common/assets/icons/search-icon.svg";

function TextField({
  model,
  attr,
  value,
  label,
  placeholder,
  onChange,
 isTextArea,
  disabled,
  required,
  autoFocus,
  sufix,
  prefix,
  isClassicInput
}: IPropsInputField) {
  return (
    <InputField
      type='text'
      attr={attr}
      value={value}
      label={label}
      isClassicInput={isClassicInput}
      placeholder={placeholder}
      model={model}
      onChange={onChange}
      isTextArea={isTextArea}
      disabled={disabled}
      required={required}
      autoFocus={autoFocus}
      sufix={sufix}
      prefix={prefix}
    ></InputField>
  );
}

export default TextField;